<template>
  <!-- Mirrors UiSideBarMenuSideMenu's aside shell so the sidebar keeps its
       shape while categories load. -->
  <aside
    class="w-full bg-white shadow-[0_8px_30px_rgb(0,0,0,0.04)] rounded-xl lg:rounded-2xl p-4 md:p-5 overflow-hidden animate-pulse"
  >
    <div class="flex flex-col gap-3">
      <div
        v-for="i in rows"
        :key="i"
        class="flex items-center justify-between py-2"
      >
        <div
          class="h-4 bg-gray-100 rounded"
          :style="{ width: widths[i % widths.length] }"
        ></div>
        <div class="h-3 w-3 bg-gray-100 rounded"></div>
      </div>
    </div>
  </aside>
</template>

<script setup>
defineProps({
  rows: {
    type: Number,
    default: 7,
  },
});
// Varied widths so the skeleton rows read as distinct menu items.
const widths = ["70%", "55%", "80%", "45%", "65%", "50%", "75%"];
</script>
